module.exports = __webpack_public_path__ + "img/2-2.781a52cb.svg";